import axios from 'axios';
import moment from 'moment';
import React, { Component, createRef, Fragment } from 'react';
import Navigation from '../../components/navigation.components';
import FilterComponent from '../../components/filter.component';
import Sidebar from '../../components/sidebar.component'

import { Button, Modal, Spinner } from 'react-bootstrap';
import { withRouter, useLocation } from 'react-router-dom';

import { MDBDataTable } from 'mdbreact';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'mdbreact/dist/css/mdb.css';

import "./style.css";


import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPen } from '@fortawesome/free-solid-svg-icons'
import EmpowerTalentService from '../../components/empower.component';
import TicketCounter from '../../components/counter.component';




class Admin extends Component {

	state = {
		page: {
			loaded: false
		},
		formStatus: {
			submitted: false
		},
		modals: {
			update: false
		},
		logs: {
			status: "",
			resolver: "",
			notes: "",
			file: []
		},
		filter: {
			status: "new",
			type: "all",
			cluster: "all",
			date: {
				startDate: null,
				endDate: null
			}
		},
		formErrors: [],
		selected: null,
		tickets: [],
		clusters: [],
		exportData: [],
		isShowSidebar: false
	}





	componentDidMount() {

		let params = new URLSearchParams(this.props.location.search);
		let status = params.get('status'); // bar
		let type = params.get('type'); // bar
		let from = params.get('from');
		let to = params.get('to');

		this.dateRangeRef = createRef();


		let { filter } = { ...this.state };
		if (status !== null && status !== "") filter.status = status
		if (type !== null && type !== "") filter.type = type
		if (from !== null && from !== "" && from !== "null") filter.date.startDate = from
		if (to !== null && to !== "" && to !== "null") filter.date.endDate = to

		this.setState({ ...this.state, filter }, () => {
			this.getAllCluster();
			this.getAllTickets();
		});
	}

	getAllCluster = () => {
		let token = localStorage.getItem('access-token');
		// console.log(69, this.state.filter);
		axios.get('/api/tickets/clusters', {
			headers: {
				'Authorization': `Bearer ${token}`
			},
		}).then(res => {
			let { status, data } = res.data;
			if (status) {
				let { clusters } = this.state;
				clusters = data;
				this.setState({ ...this.state, clusters });
			}
		}).catch(err => {
			console.log(err)
			alert('[Error code: getAllCluster] Something went wrong. please contact administrator');
		})
	}

	getAllTickets = props => {
		let token = localStorage.getItem('access-token');
		// console.log(69, this.state.filter);
		axios.get('/api/tickets', {
			headers: {
				'Authorization': `Bearer ${token}`
			},
			params: this.state.filter
		}).then(res => {
			let { status, data } = res.data;
			if (status) {
				let { page, tickets } = this.state;
				page.loaded = true;
				tickets = data;
				this.setState({ page, tickets });
			}
		}).catch(err => {
			console.log(err)
			alert('[Error code: getAllTickets] Something went wrong. please contact administrator');
		})
	}



	capitalize(str) {
		return str ? str.charAt(0).toUpperCase() + str.slice(1) : "";
	}

	openUpdateModalHandler = (e, ticket) => {
		e.preventDefault();
		let { modals, formStatus, selected } = { ...this.state };
		modals.update = true;
		formStatus.submitted = false;
		selected = ticket;
		this.setState({ ...this.state, modals, formStatus, selected });
	}

	closeUpdateModalHandler = e => {
		let { modals, formStatus, selected } = { ...this.state };
		modals.update = false;
		formStatus.submitted = false;
		selected = null;
		this.setState({ ...this.state, modals, formStatus, selected }, () => {
			this.getAllTickets()
		});
	}

	// changeInputHandler = e => {
	// 	let selected = { ...this.state.selected };
	// 	selected.notes = e.target.value;
	// 	this.setState({ selected });
	// }

	submitStatusHandler = e => {
		let { formStatus, selected, logs, formErrors } = this.state;

		if (logs.status === "") {
			if (!formErrors.includes('status')) formErrors.push('status');
		}

		if (formErrors.length > 0) {
			this.setState({ formErrors });

		} else {
			formStatus.submitted = true;
			this.setState({ formStatus });

			let user = JSON.parse(localStorage.getItem('user'));

			let data = {
				status: logs.status,
				notes: logs.notes,
				user: `${user.employee_first_name} ${user.employee_last_name}`
			}

			// ------ Attachment
			let FD = new FormData();

			if (logs.file !== null) {
				for (const key of Object.keys(logs.file)) {
					FD.append('file', logs.file[key], `-emp-${logs.file[key].name}`)
				}
			}
			FD.append('files', logs.file);
			FD.append('status', logs.status);
			FD.append('notes', logs.notes);
			FD.append('user', data.user);
			// ./ ------ Attachment

			axios.put(`/api/tickets/status/${selected._id}`, FD, {
				headers: {
					Authorization: 'Bearer ' + localStorage.getItem('access-token')
				}
			}).then(response => {
				let { formStatus, selected, logs } = { ...this.state }
				logs = {
					notes: "",
					status: "",
					resolver: "",
					file: []
				}
				selected = response.data.data;
				formStatus.submitted = false;
				this.setState({ ...this.state, formStatus, selected, logs }, () => {
					toast.success('Successfully updated ticket', {
						position: "bottom-left",
						autoClose: 5000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: false,
						draggable: true,
						progress: undefined,
					});
				});
			}).catch(err => {
				let { formStatus } = { ...this.state }
				formStatus.submitted = false;
				this.setState({ ...this.state, formStatus }, () => {
					toast.error('Something went wrong! Please try again later.', {
						position: "bottom-left",
						autoClose: 5000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: false,
						draggable: true,
						progress: undefined,
					});
				});
			})
		}
	}

	logsInputHandler = e => {
		let { logs, formErrors } = this.state
		if (formErrors.includes(e.target.name)) {
			let idx = formErrors.indexOf(e.target.name);
			formErrors.splice(idx, 1);
		}
		logs[e.target.name] = e.target.value
		this.setState({ ...this.state, logs, formErrors });
	}

	filterHandler = () => {
		let { page, isShowSidebar } = {...this.state};
		page.loaded = false;
		isShowSidebar = false
		this.setState({ page, isShowSidebar }, this.getAllTickets());

		this.props.history.push({
			pathname: '/admin',
			search: `?status=${this.state.filter.status}&type=${this.state.filter.type}&from=${this.state.filter.date.startDate}&to=${this.state.filter.date.endDate}&cluster=${this.state.filter.cluster}`
		});
	}







	attachFileHandler = (e, fileIdx) => {
		let { logs, formErrors } = { ...this.state };
		let allowedMimeTypes = [
			'image/gif',
			'image/jpeg',
			'image/png',
			'application/pdf',
			'application/msword',
			'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
			'application/vnd.ms-excel',
			'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
			'application/vnd.ms-powerpoint',
			'application/vnd.openxmlformats-officedocument.presentationml.presentation'
		];
		let allowedSize = 1000000;
		let files = e.target.files;

		let error = [];
		for (let i = 0; i < files.length; i++) {
			if (files[i].size > allowedSize || !allowedMimeTypes.includes(files[i].type)) {
				error.push(files[i]);
			}
		}

		if (error.length > 0) {
			if (!formErrors.includes(`${fileIdx}_file`)) formErrors.push(`${fileIdx}_file`);
		} else {
			if (formErrors.includes(`${fileIdx}_file`)) {
				let fIdx = formErrors.indexOf(`${fileIdx}_file`);
				formErrors.splice(fIdx, 1);
			}
			logs.file = files
		}

		this.setState({ ...this.state, logs, formErrors });
	}

	viewAttachedFiles = () => {
		let logs = this.state.logs;

		let data = [];

		if (logs.file.length > 0) {
			for (let i = 0; i < logs.file.length; i++) {
				data.push(
					<div className="chip" key={i}>
						<span>{logs.file[i].name}</span>
						<a
							href="#"
							className="close"
							onClick={e => this.removeAttachment(e, i)}
						>
							<i className="bi bi-x"></i>
						</a>
					</div>
				)
			}
		}

		return data;
	}

	removeAttachment = (e, fileIdx) => {
		e.preventDefault();
		let logs = this.state.logs;
		logs.file = Array.from(logs.file);
		logs.file.splice(fileIdx, 1);
		this.setState({ logs });
	}

	exportToCSV = e => {
		e.preventDefault();
		axios.get(`/api/tickets/export-to-csv`, {
			params: this.state.filter,
			headers: {
				Authorization: 'Bearer ' + localStorage.getItem('access-token')
			}
		}).then(response => {

		}).catch(err => {

		})
	}

	exportDataFromTickets = (e) => {
		let { exportData, tickets } = { ...this.state };

		tickets.map(ticket => {
			let lastLog = ticket.logs[ticket.logs.length - 1];
			let aging = moment(ticket.createdAt).fromNow().replace(/,/g, '');

			if (["completed", "duplicate", "cancelled"].includes(lastLog.status)) {
				// aging = `Completed at ${moment(lastLog.date).format("MMM D YYYY")}`
				let createdAtMoment = moment(ticket.createdAt);
				let lastLogMoment = moment(lastLog.date);
				let diff = moment.duration(lastLogMoment.diff(createdAtMoment));

				let diffDays = diff.asDays();
				let diffHours = diff.asHours();
				let diffMins = diff.asMinutes();

				aging = `${Math.floor(diffDays)} Day/s`;

				if (diffDays < 1) {


					aging = `${Math.floor(diffMins)} Min`;

					if (diffMins > 60) {
						aging = `${Math.floor(diffHours)} Hour/s`
					}
				}
			}

			let concern = ticket.concern;

			// regular expression
			concern = concern.replace(/"/g, '""');
			concern = concern.replace(/,/g, '\,');
			concern = concern.replace(/'/g, '\'');

			exportData.push({
				'Ticket#': ticket.ticketId,
				Inquiry: ticket.typesOfInquiry,
				"Pay Period": ticket.requestDate ? moment(ticket.requestDate).format('YYYY/MM/DD') : "",
				Category: ticket.category.name,
				Subcategory: ticket.subcategory,
				Name: ticket.name.includes(",") ? ticket.name.replace(/,/g, '') : ticket.name,
				Email: ticket.email,
				Mobile: ticket.mobile,
				EEID: ticket.employeeID,
				Concern: concern,
				Aging: aging,
				Cluster: ticket.cluster,
				// Files: ticket.files,
				'Submitted At': moment(ticket.createdAt).format("MMM D YYYY hh:mm a"),
				Status: lastLog.status,
				"Status Updated By": lastLog.user,
				"Status Updated At": `${moment(lastLog.date).format("MMM D YYYY hh:mm a")}`,
			})
		})

		this.setState({ ...this.state, exportData })
	}

	handleSideBar = () => {
		let { isShowSidebar } = { ...this.state }
		isShowSidebar = !isShowSidebar;
		this.setState({ ...this.state, isShowSidebar })
	}

	getActions = (e, field, data = null) => {
		e && e.preventDefault && e.preventDefault();
		let { page } = {...this.state};
		
		
		switch (field) {

			case 'filter':
				this.state[field] = data;
				this.setState({ ...this.state })
				break;

			case 'filterHandler':
				this.filterHandler()
				
				break;

			
		}

	}


	getActionsCsv = (e, done) =>{
		this.exportDataFromTickets(e);
		done();
	}

	render() {
		let { page, tickets, formStatus, modals, selected, logs, formErrors, filter, clusters } = this.state;

		let lastLog = selected !== null ? selected.logs[selected.logs.length - 1] : null;

		let data = {
			columns: [
				{ label: 'Ticket#', field: 'ticket_id', },
				{ label: 'Inquiry', field: 'type_of_inquiry', },
				{ label: 'Category', field: 'category', },
				{ label: 'Pay Period', field: 'request_date', },
				{ label: 'Name', field: 'name', },
				{ label: 'EE ID', field: 'employee_id', },
				{ label: 'Submitted At', field: 'submitted_at', sort: 'desc' },
				{ label: 'Aging', field: 'aging' },
				{ label: 'Status', field: 'status', },
				{ label: 'Cluster', field: 'cluster' },
				{ label: 'Actions', field: 'actions', },
			],
			rows: []
		}


		if (tickets.length > 0) {

			tickets.map(ticket => {
				let finalLog = ticket.logs.length > 0 ? ticket.logs[ticket.logs.length - 1] : "new";

				data.rows.push({
					ticket_id: ticket.ticketId,
					type_of_inquiry: this.capitalize(ticket.typesOfInquiry),
					request_date: ticket.requestDate ? moment(ticket.requestDate).format('YYYY-MM-DD') : "",
					category: `${ticket.category?.name ? ticket.category.name : ""} ${ticket.subcategory ? `(${ticket.subcategory})` : ""}`,
					name: ticket.name,
					cluster: ticket.cluster,
					employee_id: ticket.employeeID,
					submitted_at: moment(ticket.createdAt).format("MMM D YYYY hh:mm a"),
					aging: moment(ticket.createdAt).fromNow(),
					status: this.capitalize(finalLog.status),
					actions: <button className='btn btn-sm btn-primary' style={{ margin: 0 }} onClick={e => this.openUpdateModalHandler(e, ticket)} ><FontAwesomeIcon icon={faPen} /></button>,
				})
			})
		}

		let lastname = "";
		if (selected !== null) {
			let spliceName = selected.name.split(" ");
			let lastString = spliceName[spliceName.length - 1];
			lastname = lastString;
		}

		let dateFrom = filter.date.startDate;
		if (dateFrom === null) {
			//check if meorn na sa from url
			const urlSearchParams = new URLSearchParams(window.location.search);
			const params = Object.fromEntries(urlSearchParams.entries());

			if (params.from !== "null") {
				dateFrom = moment(params.from)
			} else {
				dateFrom = moment()
			}
		}

		let dateTo = filter.date.endDate;
		if (dateTo === null) {
			//check if meorn na sa from url
			const urlSearchParams = new URLSearchParams(window.location.search);
			const params = Object.fromEntries(urlSearchParams.entries());

			if (params.to !== "null") {
				dateTo = moment(params.to)
			} else {
				dateTo = moment()
			}
		}

		let value = "";

		if (filter.date.endDate !== null && filter.date.startDate !== null) {
			value = `${moment(dateFrom).format('MM/DD/YYYY')} - ${moment(dateTo).format('MM/DD/YYYY')}`
		}


		return <>
			<Navigation handleShow={this.handleSideBar} />
			<Sidebar isShow={this.state.isShowSidebar} onHide={this.handleSideBar} >
				<FilterComponent
					dateFrom={dateFrom}
					dateTo={dateTo}
					filter={filter}
					value={value}
					clusters={clusters}
					exportData={this.state.exportData}
					getActions={this.getActions}
					getActionsCsv={this.getActionsCsv}

				/>
			</Sidebar>
			<ToastContainer
				position="bottom-left"
				autoClose={5000}
				hideProgressBar={true}
				newestOnTop={true}
				closeOnClick
				rtl={false}
				pauseOnFocusLoss
				draggable={false}
				pauseOnHover
			/>


			<Modal
				show={modals.update}
				size="lg"
				fullscreen
				onHide={e => this.closeUpdateModalHandler(e)}
				backdrop="static"
				keyboard={false}
			>
				<Modal.Header closeButton={!formStatus.submitted}>
					<Modal.Title>Ticket {selected !== null && selected.ticketId.toUpperCase()}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{selected &&
						<div className='row justify-content-center'>
							<div className="col-7">
								<h5 className="text-center">Ticket Details</h5>
								<dl className="row mt-3">
									<dt className="col-sm-2">Submitted at</dt>
									<dd className="col-sm-10">{moment(selected.createdAt).format("MMM D YYYY hh:mm a")}</dd>

									<dt className="col-sm-2">Type of Inquiry</dt>
									<dd className="col-sm-10" style={{ textTransform: 'capitalize' }}>{selected.typesOfInquiry}</dd>

									{/* <dt className="col-sm-2">Type</dt>
									<dd className="col-sm-10">{selected.existingEmaptaEmployee ? "Employee" : "Non Employee"}</dd> */}

									<dt className="col-sm-2">Category</dt>
									<dd className="col-sm-10">{selected.category?.name}</dd>

									<dt className="col-sm-2">Pay Period</dt>
									<dd className="col-sm-10">{selected.requestDate ? moment(selected.requestDate).format("ddd, MMM DD YYYY") : ""}</dd>

									<dt className="col-sm-2">Subcategory</dt>
									<dd className="col-sm-10">{selected.subcategory}</dd>

									<dt className="col-sm-2">Name</dt>
									<dd className="col-sm-10" style={{ textTransform: 'capitalize' }}>{selected.name}</dd>

									<dt className="col-sm-2">Email</dt>
									<dd className="col-sm-10">{selected.email}</dd>

									<dt className="col-sm-2">Mobile</dt>
									<dd className="col-sm-10">{selected.mobile}</dd>


									<dt className="col-sm-2">Employee ID</dt>
									<dd className="col-sm-10">{selected.employeeID}</dd>

									<dt className="col-sm-2">Concern</dt>
									<dd className="col-sm-10">{selected.concern}</dd>

									{/* <dt className="col-sm-2">Status</dt>
									<dd className="col-sm-10">{this.capitalize(selected.status)}</dd> */}

									<dt className="col-sm-12 mt-2">Ticket sent to</dt>
									<dd className="col-sm-12">{selected.sendTo}</dd>

									{selected.files.length > 0 &&
										<>
											<dt className="col-sm-12 mt-2">Attachments</dt>
											<dd className="col-sm-12">
												<ul>
													{selected.files.map((file, idx) => <li key={idx}> <a href={file} target="_blank">{file}</a> </li>)}
												</ul>

											</dd>
										</>
									}
								</dl>

								<div className='row'>
									<h5>Logs</h5>
									{selected.logs.map((log, idx) => {
										return (
											<div className='col-12 card p-3 mt-3' key={idx}>
												<h6 style={{ textTransform: 'capitalize' }}>{log.status}</h6>
												{log.notes && <p style={{ margin: 0, padding: 0 }}> {log.notes} </p>}

												{log.hasOwnProperty('files') ?
													log.files.map((file, idx) => {
														return <a key={idx} href={file} target="_blank">{file}</a>
													})
													:
													null
												}
												<p style={{ margin: 0, padding: 0 }}> -<i style={{ textTransform: 'capitalize' }}>{log.user}, {moment(log.date).format('ddd MMM D, YYYY hh:mm A')}</i></p>
											</div>
										)
									})}
								</div>

								{lastLog !== null && !['cancelled', 'duplicate', 'moved to follow up'].includes(lastLog.status) &&
									<div className="row mt-5">
										<form>
											<div className='mb-3'>
												<label htmlFor='status'>Status *</label>
												<select
													name="status"
													id="status"
													disabled={formStatus.submitted}
													className={`form-control ${formErrors.includes('status') ? 'is-invalid' : ""}`}
													value={logs.status}
													onChange={e => this.logsInputHandler(e)}
												>
													<option value="">Select</option>
													<option value="Worked In Progress">Worked In Progress</option>
													<option value="Resolved">Resolved</option>
													<option value="Additional Information Required">Additional Information Required</option>
												</select>
											</div>

											<div className="mb-3">
												<label>FILES </label>
												<div className="file-upload ">
													<div className="file-upload-btn" >
														<label style={formErrors.includes(`attachment`) ? { borderColor: 'red' } : {}} >
															<i className="bi bi-paperclip"></i>
															Attach File
														</label>
														<input
															type="file"
															id="file"
															name='file'
															multiple
															className="form-control"
															onChange={e => this.attachFileHandler(e)}
															disabled={logs.submitted}
														/>
													</div>
													<span className="text-muted"><i>Only accepts gif, jpeg, png, pdf and doc files with size not greater than 1mb and limits only to 3 items</i></span>

													<div className="attach-chips">
														{logs.file !== null && this.viewAttachedFiles(logs.file)}
													</div>
												</div>
											</div>

											<div className='mb-3'>
												<label htmlFor='notes'>Notes</label>
												<textarea
													name="notes"
													className='form-control'
													id="notes"
													cols={64}
													rows={2}
													style={{ resize: 'none' }}
													value={logs.notes}
													onChange={e => this.logsInputHandler(e)}
													disabled={formStatus.submitted}
												/>
											</div>
											<div className='row mb-3'>
												<div className='col-12'>
													<button
														type="button"
														style={{ float: "right", display: 'inline-block' }}
														className="btn btn-primary btn-sm "
														onClick={e => this.submitStatusHandler(e)}
														disabled={formStatus.submitted}
													>
														Submit
													</button>
												</div>
											</div>

										</form>
									</div>
								}
							</div>
							{selected.employeeID &&
								<div className='col-5 border p-3'>
									<EmpowerTalentService employee-id={selected.employeeID} employee-lastname={lastname} />
								</div>
							}
						</div>
					}
				</Modal.Body>

			</Modal>
			{page.loaded ?
				<div className='container-fluid'>

					<TicketCounter />

					<div className="row mt-5">
						<div className="col-12">
							<MDBDataTable
								responsive
								striped
								bordered
								hover
								noBottomColumns
								data={{ ...data }}
								entriesOptions={[10, 30, 50]}
							
							/>
						</div>

					</div>

				</div>
				: <div className='container'>
					<Spinner animation="border" variant="secondary" />
					Loading...
					</div>
			}
		</>


	}
}


export default withRouter(Admin);

